module.exports = __webpack_public_path__ + "static/media/logo.2c514768.png";